import { ComponentProps } from "react";

import { SelectProps } from "antd";

import { CampaignOptionLabel } from "./CampaignFormOption";

export const campaignSelectMatchesValue: Extract<SelectProps<string>["filterOption"], (...args: any[]) => any> = (
    input,
    option
) => {
    const { name, friendlyId } = (
        option?.label as unknown as React.ReactElement<ComponentProps<typeof CampaignOptionLabel>>
    )?.props?.campaign || {
        name: "",
        friendlyId: "",
    };
    const friendlyIdLabel = `${friendlyId}`; // convert to string for search
    return name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || friendlyIdLabel.indexOf(input.toLowerCase()) >= 0;
};
